import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_BASE_URL = `${configs.BACKEND_URL}/api/saved-searches`;

/**
 * Create a saved search
 * @param {string} name - Name for the saved search
 * @param {Object} filters - The filter state to save
 */
export const createSavedSearch = async (name, filters) => {
  const response = await fetchWithTenant(API_BASE_URL, {
    method: 'POST',
    body: JSON.stringify({ name, filters })
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to save search');
  }

  return response.json();
};

/**
 * Get all saved searches for the current user
 */
export const getSavedSearches = async () => {
  const response = await fetchWithTenant(API_BASE_URL);

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch saved searches');
  }

  return response.json();
};

/**
 * Rename a saved search
 * @param {string} id - The saved search ID
 * @param {string} newName - The new name
 */
export const renameSavedSearch = async (id, newName) => {
  const response = await fetchWithTenant(`${API_BASE_URL}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ name: newName })
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to rename saved search');
  }

  return response.json();
};

/**
 * Delete a saved search
 * @param {string} id - The saved search ID
 */
export const deleteSavedSearch = async (id) => {
  const response = await fetchWithTenant(`${API_BASE_URL}/${id}`, {
    method: 'DELETE'
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to delete saved search');
  }

  return response.json();
};

/**
 * Apply a saved search (updates lastUsed timestamp)
 * @param {string} id - The saved search ID
 */
export const applySavedSearch = async (id) => {
  const response = await fetchWithTenant(`${API_BASE_URL}/${id}/apply`, {
    method: 'POST'
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to apply saved search');
  }

  return response.json();
};

export default {
  createSavedSearch,
  getSavedSearches,
  renameSavedSearch,
  deleteSavedSearch,
  applySavedSearch
};
